import * as Types from '../../../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Thu Nov 20 2025 02:01:55 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type LiveStreamPanelistRedirectQueryVariables = Types.Exact<{
  hashedId: Types.Scalars['HashedId']['input'];
}>;


export type LiveStreamPanelistRedirectQuery = { __typename?: 'Query', liveEventJoinKeyForPanelistRedirect?: string | null | undefined };


export const LiveStreamPanelistRedirectDocument = gql`
    query LiveStreamPanelistRedirect($hashedId: HashedId!) {
  liveEventJoinKeyForPanelistRedirect(hashedId: $hashedId)
}
    `;

/**
 * __useLiveStreamPanelistRedirectQuery__
 *
 * To run a query within a React component, call `useLiveStreamPanelistRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveStreamPanelistRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveStreamPanelistRedirectQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *   },
 * });
 */
export function useLiveStreamPanelistRedirectQuery(baseOptions: Apollo.QueryHookOptions<LiveStreamPanelistRedirectQuery, LiveStreamPanelistRedirectQueryVariables> & ({ variables: LiveStreamPanelistRedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveStreamPanelistRedirectQuery, LiveStreamPanelistRedirectQueryVariables>(LiveStreamPanelistRedirectDocument, options);
      }
export function useLiveStreamPanelistRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveStreamPanelistRedirectQuery, LiveStreamPanelistRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveStreamPanelistRedirectQuery, LiveStreamPanelistRedirectQueryVariables>(LiveStreamPanelistRedirectDocument, options);
        }
export function useLiveStreamPanelistRedirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LiveStreamPanelistRedirectQuery, LiveStreamPanelistRedirectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LiveStreamPanelistRedirectQuery, LiveStreamPanelistRedirectQueryVariables>(LiveStreamPanelistRedirectDocument, options);
        }
export type LiveStreamPanelistRedirectQueryHookResult = ReturnType<typeof useLiveStreamPanelistRedirectQuery>;
export type LiveStreamPanelistRedirectLazyQueryHookResult = ReturnType<typeof useLiveStreamPanelistRedirectLazyQuery>;
export type LiveStreamPanelistRedirectSuspenseQueryHookResult = ReturnType<typeof useLiveStreamPanelistRedirectSuspenseQuery>;
export type LiveStreamPanelistRedirectQueryResult = Apollo.QueryResult<LiveStreamPanelistRedirectQuery, LiveStreamPanelistRedirectQueryVariables>;